import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192" {...props}>
      <path
        fill="none"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={8}
        stroke="#333"
        d="M28 130l68-68 68 68"
      />
    </svg>
  )
}

export default SvgComponent
